import { certificateConstants, uriConstants } from '../../constants'
import { defaultService } from '../../services'
import { alertActions } from '..'
import { errorMessages } from '../../messages'

export const certificateActions = {
  openPccRequest,
  resultPccInfo,
  openPccRequestV4,
  resultPccInfoV4,
  setInitialState,
}

function openPccRequest() {
  return (dispatch) => {
    dispatch(apiAction(certificateConstants.CERT_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_PCC_PARAM,
      })
      .then(
        (response) => {
          dispatch(apiAction(certificateConstants.CERT_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(certificateConstants.CERT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

// 본인인증 받은 cellNo 을 가져오기 위해서 결과정보 axios호출
function resultPccInfo(retInfo) {
  return (dispatch) => {
    dispatch(apiAction(certificateConstants.CERT_RESULT_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_PCC_RST + '/' + retInfo,
      })
      .then(
        (response) => {
          dispatch(apiAction(certificateConstants.CERT_RESULT_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(certificateConstants.CERT_RESULT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

// ============================ V4 (SIREN24 seed_v4) ============================
// reqNum을 member_id 기반 유니크 값으로 생성하는 V4 파라미터 조회.
// memberId: 회원가입 흐름에서 입력한 아이디(옵션). 미전달 시 서버가 로그인 사용자/익명으로 처리.
function openPccRequestV4(memberId) {
  return (dispatch) => {
    dispatch(apiAction(certificateConstants.CERT_REQUEST))

    const query = memberId ? `?memberId=${encodeURIComponent(memberId)}` : ''
    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_PCC_PARAM_V4 + query,
      })
      .then(
        (response) => {
          dispatch(apiAction(certificateConstants.CERT_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(certificateConstants.CERT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

// V4 결과 조회: 표준창이 회신한 crypto_token_id로 StoS 호출 결과를 받아온다.
function resultPccInfoV4(cryptoTokenId) {
  return (dispatch) => {
    dispatch(apiAction(certificateConstants.CERT_RESULT_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_PCC_RST_V4 + '/' + cryptoTokenId,
      })
      .then(
        (response) => {
          dispatch(apiAction(certificateConstants.CERT_RESULT_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(certificateConstants.CERT_RESULT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function setInitialState() {
  return (dispatch) => {
    dispatch(apiAction(certificateConstants.CERT_SET_INITIAL_STATE))
  }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}
